<template>
  <BaseModal
    :modal-id="modalCreateReviewSuccessId"
    content-style="max-width: 395px;width: calc(100svw - 32px)"
  >
    <template #default="{ close }">
      <div class="modal-body">
        <div class="review-success__content">
          <div class="review-success__icon icon-thank" />
          <p class="review-success__title h4">
            {{ $t('reviews.thank') }}
          </p>

          <p v-if="isSellerPage" class="review-success__text">
            {{ $t('reviews.thank_text_seller') }}
          </p>

          <p v-else-if="email" class="review-success__text">
            {{ isConfirmedEmail ? $t('reviews.thank_text') : $t('reviews.confirm_your_mail_text') }}
            <span class="review-success__email">{{ email }}</span>
          </p>

          <p v-else class="review-success__text">
            {{ $t('reviews.add_email_for_letters_in_profile') }}
          </p>

          <BaseButton
            outline
            full-width
            class="review-success__submit"
            @click="close"
          >
            {{ $t('common.understood') }}
          </BaseButton>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { modalCreateReviewSuccessId } from '~/constants/modalNames'
import { useAuthUserStore } from '~/stores/auth-user'

interface Props {
  isSellerPage?: boolean
}

withDefaults(defineProps<Props>(), { isSellerPage: false })

const authUserStore = useAuthUserStore()

const email = computed<string>(() => {
  return authUserStore.data?.email || ''
})

const isConfirmedEmail = computed<boolean>(() => {
  return authUserStore.data?.is_confirmed_email || false
})

</script>

<style scoped lang="scss">
.review-success {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__icon {
    font-size: 4rem;
    margin-bottom: 1.3rem;
    color: $font-accent-color;
  }

  &__title {
    margin-bottom: 1.6rem;
  }

  &__text {
    margin-bottom: 2.4rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  &__email {
    font-weight: 500;
  }

  &__submit {
    font-weight: 400;
  }
}
</style>
